module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    staticClass: "icon",
    attrs: {
      "transform": _vm.transform
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showDetail($event)
      }
    }
  }, [_c('use', {
    attrs: {
      "x": "0",
      "y": "0",
      "width": _vm.visualizationPinSize.width,
      "height": _vm.visualizationPinSize.height,
      "fill": _vm.visualizationPinColor,
      "transform": _vm.visualizationPinTransform,
      "xlink:href": "#pin-person"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29bfec80","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/pin/person/single.vue
// module id = 750
// module chunks = 0